'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 4.35779e-05C9.33328 -4.89918e-05 18.6666 3.46968e-05 27.9998 3.46968e-05C28.0011 6.6667 28 13.3334 28 20C18.6667 20 9.33333 20 0 20V4.35779e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.3335 20H18.6668V3.46968e-05H9.3335V20Z",
          fill: "#146BBC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H9.3335V3.46968e-05L0 4.35779e-05V20Z",
          fill: "#E43642"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.6668 20H28L27.9998 3.46968e-05H18.6668V20Z",
          fill: "#E43642"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.66667 10L5.33333 10.6667H4.66667H4L4.66667 10Z",
          fill: "#F8D246"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33301 14.021V14.6667H4L4.66667 16L5.33301 14.6667V16H6.66634V12H5.33333H4.67195C5.03771 11.9972 5.33333 11.6998 5.33333 11.3334C5.33333 10.9652 5.03486 10.6667 4.66667 10.6667C4.29848 10.6667 4 10.9652 4 11.3334C4 11.6998 4.29563 11.9972 4.66138 12H4L4.66666 13.3333C4.29847 13.3333 4 13.6318 4 14C4 14.3682 4.29848 14.6667 4.66667 14.6667C5.02782 14.6667 5.3219 14.3795 5.33301 14.021ZM5.33301 13.979L5.33333 12L4.66666 13.3333C5.0278 13.3333 5.3219 13.6205 5.33301 13.979Z",
          fill: "#F8D246"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M2.6665 12H4L3.99984 16H2.6665V12Z", fill: "#F8D246" })
    ]
  }
);
const VpFlagMnAsset = forwardRef(FlagMnAsset);

export { VpFlagMnAsset as default };
